import styles from './Quote.module.scss';

interface QuoteProps {
  quote: string;
  author: string;
  avatarUrl?: string;
  isTrustPilot?: boolean;
}

export const Quote = ({ quote, author, avatarUrl = '', isTrustPilot }: QuoteProps) => (
  <div className={`${styles.container}`}>
    <div className={`${styles.backdrop}`}>
      {/* Used img tag to auto-scale SVG while preserving aspect ratio  */}
      <img width={472} alt="backdrop" src="/next-assets/images/cohort/hiw-backdrop.svg" />
    </div>
    <div className={`${styles.card}`}>
      {isTrustPilot && <img width={232} alt="trustpilot" src="/next-assets/images/cohort/trustpilot.svg" />}
      <p className={`${styles.quote}`}>{quote}</p>
      <span className={`${styles.authorContainer}`}>
        {avatarUrl && <img className={`${styles.avatar}`} src={avatarUrl} alt="avatar" width={48} height={48} />}
        <p className={`${styles.author}`}>{author}</p>
      </span>
    </div>
  </div>
);
